// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__3DnLS","unreadBadge":"styles_unreadBadge___s3NV","modalContent":"styles_modalContent__LK8Io","modal":"styles_modal__32FUQ"};